import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Box, ContentBlock, Loader } from "braid-design-system";
import { useState, useRef, useEffect } from "react";
import { StepFooter } from "../../private/components/Stepper/StepFooter/index.mjs";
import { StepHeader } from "../../private/components/Stepper/StepHeader/index.mjs";
import { loading, faded } from "./index.css.mjs";
const successActionResult = { success: true };
const Step = ({
  children,
  onClickNext,
  onClickNextAsync,
  onClickGoBack,
  onActive,
  onCancel,
  onClickHeaderPoint = (_fromStepIndex, _toStepIndex) => {
  },
  footerNotification,
  goToStepIndex = (_) => {
  },
  saveButtonLabel,
  stepHeaderClassName,
  stepBodyClassName,
  stepContentClassName,
  onServerError,
  stepNames = [],
  stepIndex = 0,
  maxStepIndexVisited = 0,
  title,
  activeStepIndex
}) => {
  const [stepActionError, setStepActionError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const previousActiveStepIndexRef = useRef(void 0);
  useEffect(() => {
    const isActive = stepIndex === activeStepIndex;
    const previousIsActive = stepIndex === previousActiveStepIndexRef.current;
    if (!previousIsActive && isActive && onActive) {
      onActive();
    }
    previousActiveStepIndexRef.current = activeStepIndex;
  }, [stepIndex, activeStepIndex, onActive]);
  if (stepIndex !== activeStepIndex) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const onLeaveStep = async () => {
    let actionResult = successActionResult;
    setIsLoading(false);
    setStepActionError(null);
    if (onClickNext) {
      actionResult = onClickNext();
    }
    if (onClickNextAsync) {
      setIsLoading(true);
      try {
        actionResult = await onClickNextAsync();
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    }
    if (actionResult.error) {
      setStepActionError(actionResult.error);
    }
    return actionResult;
  };
  const onNextFunc = async () => {
    const actionResult = await onLeaveStep();
    if (actionResult.success && goToStepIndex) {
      goToStepIndex(stepIndex + 1);
    }
  };
  const onGoBackFunc = () => {
    if (onClickGoBack) {
      onClickGoBack();
    }
    if (goToStepIndex) {
      goToStepIndex(stepIndex - 1);
    }
  };
  const onClickProgressPoint = async (progressStepIndex) => {
    if (progressStepIndex < stepIndex) {
      goToStepIndex(progressStepIndex);
      if (onClickHeaderPoint) {
        onClickHeaderPoint(activeStepIndex, progressStepIndex);
      }
    } else if (progressStepIndex > stepIndex && progressStepIndex <= maxStepIndexVisited) {
      const actionResult = await onLeaveStep();
      if (actionResult.success) {
        goToStepIndex(progressStepIndex);
        if (onClickHeaderPoint) {
          onClickHeaderPoint(activeStepIndex, progressStepIndex);
        }
      }
    }
  };
  const stepActionErrorMessage = (stepActionError == null ? void 0 : stepActionError.errorMessage) ?? "";
  const errorMessage = stepActionErrorMessage === "" ? void 0 : stepActionErrorMessage;
  const handleError = onServerError && (stepActionError == null ? void 0 : stepActionError.isServerError) ? onServerError : void 0;
  const stepHeaderProps = {
    title,
    stepNames,
    activeStepIndex,
    onClickProgressPoint,
    maxStepIndexVisited,
    stepHeaderClassName
  };
  const stepFooterProps = {
    stepIndex,
    totalSteps: stepNames.length,
    footerNotification,
    saveButtonLabel,
    isLoading,
    onClickNext: onNextFunc,
    onClickBack: onGoBackFunc,
    onClickCancel: onCancel,
    errorMessage,
    handleError
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(StepHeader, { ...stepHeaderProps }),
    /* @__PURE__ */ jsx(ContentBlock, { children: /* @__PURE__ */ jsxs(Box, { background: "surface", height: "full", className: stepBodyClassName, children: [
      /* @__PURE__ */ jsxs(Box, { paddingBottom: "xxlarge", marginBottom: "large", children: [
        isLoading ? /* @__PURE__ */ jsx(Box, { className: loading, children: /* @__PURE__ */ jsx(Loader, {}) }) : null,
        /* @__PURE__ */ jsx(
          Box,
          {
            className: {
              [faded]: isLoading
            },
            children: /* @__PURE__ */ jsx(Box, { className: stepContentClassName, paddingX: "large", children })
          }
        )
      ] }),
      /* @__PURE__ */ jsx(StepFooter, { ...stepFooterProps })
    ] }) })
  ] });
};
export {
  Step
};
